import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const setCustomerSuppressed = {
  name: "setCustomerSuppressed" as const,
  input: z.object({
    customerId: zExt.objectId(),
    action: createEnum(["suppress", "unsuppress"]),
    channel: createEnum(MarketingChannel),
  }),
  output: z.object({}),
};
